import { makeStyles } from "@material-ui/core";
import * as React from "react";

import theme from "@/theme";

const useStyles = makeStyles(() => ({
  root: {
    display: "inline-flex", alignItems: "center", alignSelf: "flex-start", gap: 3, height: 27,
    color: theme.palette.semantic["action/primary"], fontSize: 12, fontWeight: 700, lineHeight: 1.5,
    whiteSpace: "nowrap", "& img": { display: "block", flexShrink: 0 },
  },
  dark: { color: theme.palette.semantic["text/inverse"] },
}));

export const CertifiedPlannerBadge: React.FC<{ surface?: "light" | "dark" }> = ({ surface = "light" }) => {
  const classes = useStyles();
  return (
    <span className={`${classes.root} ${surface === "dark" ? classes.dark : ""}`} data-testid="certified-planner-badge">
      <img src={`/icons/planner_onboarding/certification_${surface === "dark" ? "gold" : "blue"}.svg`} alt="" />
      認定プランナー
    </span>
  );
};
